<nz-spin nzTip='Verifying email...' [nzSpinning]="loading" nzSize="large">
  <nz-alert
    *ngIf="apiResponded"
    [nzType]="msgType"
    [nzDescription]="msgText">
  </nz-alert>
  <form nz-form nzLayout="vertical" [formGroup]="form" (ngSubmit)="onSubmit()">
    <nz-form-item>
      <nz-form-label [nzRequired]="true">Password</nz-form-label>
      <nz-form-control [nzErrorTip]="passwordErrorTipTpl">
        <nz-input-group [nzPrefix]="prefixLock" nzSize="large">
          <input [type]="passwordVisible ? 'text' : 'password'" nz-input formControlName="password" name="password"
                 placeholder="New password" autocomplete="new-password" type="password" id="password">
        </nz-input-group>
        <ng-template #suffixTemplate>
          <em nz-icon [nzType]="passwordVisible ? 'eye-invisible' : 'eye'"
             (click)="passwordVisible = !passwordVisible"></em>
        </ng-template>
        <ng-template #passwordErrorTipTpl>
          <app-password-validator [form]="this.form" [type]="'Password'"></app-password-validator>
        </ng-template>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item class="margin-bottom-regular">
      <nz-form-label [nzRequired]="true">Confirm your password</nz-form-label>
      <nz-form-control>
        <nz-input-group [nzPrefix]="prefixLock" nzSize="large">
          <input nz-input formControlName="passwordConfirmation" name="password_confirmation"
                 placeholder="Confirm password" type="password" id="password-confirmation">
        </nz-input-group>
      </nz-form-control>
      <app-password-validator [form]="this.form" [type]="'PasswordConfirmation'"></app-password-validator>

    </nz-form-item>

    <app-captcha [form]="form"
                 (resolved)="captchaResolved($event)">
    </app-captcha>

    <nz-form-item>
      <nz-form-control>
        <button [nzLoading]="loading"
                class="primary-button"
                [disabled]="!form.valid"
                nz-button nzSize="large" nzType="primary" nzBlock id="submit">Set
        </button>
      </nz-form-control>
    </nz-form-item>
  </form>
</nz-spin>

<a routerLink="/auth/login" nz-button nzType="primary" nzBlock nzSize="large" id="login-link"
   *ngIf="msgType !=='' && !loading">Go to Log In</a>
<ng-template #prefixLock><em nz-icon nzType="lock"></em></ng-template>
